"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instructionProcessingMatrix = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Matrix_1 = require("../../../TdWebtoolkitControls/controls/Matrix/Matrix");
const MethodManager_1 = require("../../../TdWebtoolkitControls/controls/Menu/MethodManager");
require("../../../TdWebtoolkitControls/javascript/Utilities");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
const MethodServerResponse_1 = require("../../../TdWebtoolkitControls/model/MethodServerResponse");
const $ = require("jquery");
const moment = require("moment");
const m = require("../SynView");
class instructionProcessingMatrix extends m.SynView {
    //#region CONSTRUCTOR
    constructor() {
        super();
        this._trafficLightThresholds = {
            "red": { from: 1, to: undefined },
            "yellow": { from: -6, to: 0 },
            "green": { from: undefined, to: -7 },
        };
        this.dummyDateForOneTimeInstructions = new Date(1970, 0, 1);
        this.m_hasMenu = false;
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.icon = "fa-pencil-square-o";
    }
    renderContents() {
        let that = this;
        that.m_$description = that.m_$container.find("div.description");
        that.m_$description.css("height", instructionProcessingMatrix.DescriptionPaneHeight.toString() + "px")
            .html(Utilities_1.synUtil.Strings.getValue("cefunc.221.infotext"));
        that.initMatrixControl(undefined, undefined, undefined);
    }
    resizeControls() {
        let that = this;
        if (that.m_$matrixContainer)
            that.m_$matrixContainer.synMatrix("resize", that.m_$container.innerWidth(), that.m_$container.innerHeight());
    }
    activate() {
        super.activate();
        this.logFullLicense();
    }
    onWindowFocus() {
    }
    onWindowBlur() {
    }
    setURL() {
    }
    updateSelectionContext() {
    }
    forceRefresh(modificationInfo) { }
    setSelectionContext({}) {
    }
    //#endregion Inherited from SynView
    //#region Helpers
    isInRange(val, range) {
        if (range.from != undefined && range.from > val)
            return false;
        if (range.to != undefined && range.to < val)
            return false;
        return true;
    }
    /**
    * Returns the amount of whole days a task is overdue. If the task is not overdue, the value
    * is negative. For a task being due today, 0 will be returned. If value is undefined, undefined will
    * be returned.
    * @param {Date} dueDate Due date.
    * @return {number} The amount of whole days a task is overdue.
    */
    getOverdueDays(dueDate) {
        if (!dueDate)
            return undefined;
        let now = moment(new Date()).startOf("day");
        let due = moment(dueDate);
        return now.diff(due, "days");
    }
    getTrafficLightForOverdueDays(overdueDays) {
        let that = this;
        if (overdueDays == undefined)
            return "";
        for (let prop in that._trafficLightThresholds) {
            let range = that._trafficLightThresholds[prop];
            if (that.isInRange(overdueDays, range))
                return prop;
        }
    }
    viewMergedPdf(ids, parentId, relId, udoIdList, data, close) {
        if (data.additionalInformation["cefunc.221viewmergedpdf"]) {
            let guid = Utilities_1.synUtil.getGUID();
            let dataobj = {
                "cefunc.221udoidlist": udoIdList,
                tempPathGUID: guid,
                tempPathTarget: "cefunc.221exportpath"
            };
            let contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
            let contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
            Utilities_1.synUtil.executeMethod({
                method: "cefunc.221",
                ids,
                parentId,
                relId,
                done() {
                    Utilities_1.synUtil.getAJAXData({
                        url: contentTempDownloadableUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                        done(data3) {
                            if (data3.downloadable)
                                $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&forceAttachment=true")
                                    .then(function () {
                                    close();
                                });
                        }
                    });
                },
                cleanUp() { },
                additionalData: dataobj
            });
        }
        else
            close();
    }
    initMatrixControl(ids, parentId, relId) {
        let that = this;
        that.m_$matrixContainer = that.m_$container.find("div.matrix");
        Utilities_1.synUtil.beginAjaxProgress();
        Utilities_1.synUtil.executeMethod({
            method: "cefunc.221",
            ids,
            parentId,
            relId,
            done(udosExistDataJSON) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let udosExistData = yield MethodServerResponse_1.MethodServerResponse.fromJSON(udosExistDataJSON);
                    let markup = require("../../../TdWebtoolkitControls/templates/cefunc_221.tmpl.html");
                    require.ensure(["../../../TdWebtoolkitControls/templates/cefunc_221.less"], function (require) {
                        require("../../../TdWebtoolkitControls/templates/cefunc_221.less");
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("UserInfo"),
                            done: (userDataJSON) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                //#region Initialize window contents
                                let udoQueryDocId = Utilities_1.synUtil.Configs.getValue("cefunc.221.udoquerydocid", undefined);
                                let guid = Utilities_1.synUtil.getGUID();
                                let configData = {
                                    synUtil: Utilities_1.synUtil,
                                    matrixContainerId: "matrixContainer_" + guid,
                                    matrixId: "matrix_" + guid,
                                    buttonBarId: "buttonBar_" + guid,
                                    okButtonId: "okButton_" + guid,
                                    cancelButtonId: "cancelButton_" + guid,
                                    openUdoQueryLinkId: "openUdoQueryLink_" + guid,
                                    udosExist: "Y" === udosExistData.additionalInformation["cefunc.221udosexist"],
                                    udoQueryDocId,
                                    windowID: undefined
                                };
                                // Create HTML from template
                                let template = kendo.template(markup);
                                $(".matrix").html(template(configData));
                                $("#" + configData.openUdoQueryLinkId).on("click", function () {
                                    if (udoQueryDocId)
                                        MethodManager_1.MethodManager.executeMethod("cefunc.18", [udoQueryDocId.toString()], undefined, 0, function (s, e) { }, undefined);
                                });
                                that.resizeControls();
                                //#region Initialize Matrix
                                let $matrixContainer = $("#" + configData.matrixContainerId);
                                that.m_$matrix = $("#" + configData.matrixId);
                                let initiallySelectedTag;
                                let instance = yield Instance_1.Instance.fromJSON(userDataJSON.instance);
                                let selectedTagField = Utilities_1.synUtil.Configs.getValue("cefunc.221.initiallyselectedttagfield", undefined);
                                if (selectedTagField && instance.items[selectedTagField]) {
                                    let field = instance.items[selectedTagField];
                                    if (field.multiValue && field.valueAsArray.length)
                                        initiallySelectedTag = field.value[0];
                                    else if (!field.multiValue && field.value)
                                        initiallySelectedTag = field.value;
                                }
                                that.m_$matrix
                                    .on("initSuccess", () => {
                                    that.resizeControls();
                                })
                                    .on("selectionChanged", () => {
                                    let keyCount = Object.keys(that.m_$matrix.synMatrix("getSelection")).length;
                                    Utilities_1.synUtil.toggleEnabledState($("#" + configData.okButtonId), keyCount > 0);
                                })
                                    .synMatrix({
                                    matrixId: "training",
                                    width: $matrixContainer.innerWidth(),
                                    height: $matrixContainer.innerHeight(),
                                    userHierarchyStartField: "ceaddress.matrixknoten",
                                    initiallySelectedTag,
                                    rowClickMode: Matrix_1.RowClickMode.RowSelection_All,
                                    colClickMode: Matrix_1.ColumnClickMode.Properties,
                                    cellSelectionMode: Matrix_1.CellSelectionMode.Inherit,
                                    cellRenderFunc: (physicalRowIdx, physicalColIdx, td, value, matrixData) => {
                                        td.innerHTML = "";
                                        let title = "";
                                        if (value) {
                                            let additionalData = value.additionalData || {};
                                            if (value.value && value.value.getTime() !== that.dummyDateForOneTimeInstructions.getTime()) {
                                                let overdueDays = that.getOverdueDays(value.value);
                                                let trafficLightValue = that.getTrafficLightForOverdueDays(overdueDays);
                                                if (trafficLightValue) {
                                                    let row = matrixData.dfsIndexMap[physicalRowIdx];
                                                    let col = matrixData.columns[physicalColIdx];
                                                    td.className += " trafficLight " + trafficLightValue;
                                                    let absDays = Math.abs(overdueDays);
                                                    if (trafficLightValue === "red")
                                                        title = "Überfällig seit " + absDays + " Tag" + (absDays > 1 ? "en" : "");
                                                    else if (absDays === 0)
                                                        title = "Fällig heute";
                                                    else
                                                        title = "Fällig in " + absDays + " Tag" + (absDays > 1 ? "en" : "");
                                                }
                                            }
                                            else if (additionalData.oneTimeInstruction) {
                                                td.className += " trafficLight oneTimeInstruction";
                                                title = " Einmalige Unterweisung";
                                            }
                                            if (additionalData.lastInstruction) {
                                                let lastInstructionDate = Utilities_1.synUtil.jsonToDate(additionalData.lastInstruction);
                                                if (title)
                                                    title += "\n";
                                                title += "Letzte Unterweisung: " + kendo.toString(lastInstructionDate, "d");
                                            }
                                            if (title)
                                                td.title = title;
                                        }
                                    },
                                    columnFilterPredicate: (col, srvData) => {
                                        for (let r of srvData) {
                                            if (r.values && r.values[col.id] && r.values[col.id].value)
                                                return true;
                                        }
                                        return false;
                                    }
                                });
                                //#endregion
                                //#region Initialize Buttons
                                $("#" + configData.cancelButtonId).hide();
                                $("#" + configData.okButtonId).on("click", () => {
                                    Utilities_1.synUtil.beginAjaxProgress("#" + configData.okButtonId);
                                    let udoLinkType = "web";
                                    let dataobj = {
                                        "cefunc.221action": "getudolist",
                                        "cefunc.221usersandlessons": JSON.stringify(that.m_$matrix.synMatrix("getSelection")),
                                        "cefunc.221udolinktype": udoLinkType
                                    };
                                    Utilities_1.synUtil.executeMethod({
                                        method: "cefunc.221",
                                        ids,
                                        parentId,
                                        relId,
                                        done(dataJSON) {
                                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                let udoIdList = data.additionalInformation["cefunc.221udoidlist"];
                                                if (data.additionalInformation["cefunc.221udonamelist"]) {
                                                    let udoNameList = JSON.parse(data.additionalInformation["cefunc.221udonamelist"]);
                                                    let templateMarkup = require("../../../TdWebtoolkitControls/templates/cefunc_221_udo_list.tmpl.html");
                                                    let guid = Utilities_1.synUtil.getGUID();
                                                    let configData2 = {
                                                        synUtil: Utilities_1.synUtil,
                                                        contentDiv: "contentDiv_" + guid,
                                                        udoTableId: "udoTableId_" + guid,
                                                        closeButtonId: "closeButtonId_" + guid,
                                                        windowID: undefined
                                                    };
                                                    // Create HTML from template
                                                    let template = kendo.template(templateMarkup);
                                                    $(".matrix").html(template(configData2));
                                                    // $(".matrix").contentDiv.css("box-sizing", "border-box").html(template(configData2));
                                                    let tableRef = document.getElementById(configData2.udoTableId).getElementsByTagName('tbody')[0];
                                                    // Set table headers
                                                    let newRow = tableRef.insertRow(0);
                                                    let newCell = newRow.insertCell(0);
                                                    $(newCell).css("border", "1px solid grey");
                                                    $(newCell).css("padding-left", "10px");
                                                    $(newCell).css("padding-right", "10px");
                                                    $(newCell).css("vertical-align", "middle");
                                                    $(newCell).css("background-color", "#E5EBF0");
                                                    let newElement = document.createElement('h4');
                                                    $(newElement).css("font-weight", "bold");
                                                    newElement.innerText = Utilities_1.synUtil.Strings.getValue("cefunc.221udoheader1");
                                                    newCell.appendChild(newElement);
                                                    newCell = newRow.insertCell(1);
                                                    $(newCell).css("border", "1px solid grey");
                                                    $(newCell).css("padding-left", "10px");
                                                    $(newCell).css("padding-right", "10px");
                                                    $(newCell).css("vertical-align", "middle");
                                                    $(newCell).css("background-color", "#E5EBF0");
                                                    newElement = document.createElement('h4');
                                                    $(newElement).css("font-weight", "bold");
                                                    newElement.innerText = Utilities_1.synUtil.Strings.getValue("cefunc.221udoheader2");
                                                    newCell.appendChild(newElement);
                                                    // Build table with udo names and links
                                                    for (let i = 0; i < udoNameList.length; i++) {
                                                        let udo = udoNameList[i];
                                                        let newRow = tableRef.insertRow(tableRef.rows.length);
                                                        // Name of udo including link to its property page
                                                        let newCell = newRow.insertCell(0);
                                                        $(newCell).css("border", "1px solid grey");
                                                        $(newCell).css("padding-left", "10px");
                                                        $(newCell).css("padding-right", "10px");
                                                        $(newCell).css("vertical-align", "middle");
                                                        let newElement = document.createElement('a');
                                                        if (udoLinkType === "windows") {
                                                            newElement.setAttribute("href", udo.link);
                                                            newElement.innerText = udo.name;
                                                        }
                                                        else {
                                                            newElement.setAttribute("href", udo.link);
                                                            newElement.setAttribute("target", "_blank");
                                                            newElement.innerText = udo.name;
                                                        }
                                                        newCell.appendChild(newElement);
                                                        // Number of users and popup with list of user names
                                                        newCell = newRow.insertCell(1);
                                                        $(newCell).css("border", "1px solid grey");
                                                        $(newCell).css("padding-left", "10px");
                                                        $(newCell).css("padding-right", "10px");
                                                        $(newCell).css("vertical-align", "middle");
                                                        $(newCell).css("text-align", "right");
                                                        let newElement2 = document.createElement('h5');
                                                        newElement2.innerText = udo.users.length;
                                                        newElement2.title = udo.users.join("\r\n");
                                                        newElement2.style.cursor = "help";
                                                        newCell.appendChild(newElement2);
                                                    }
                                                    // Close button click event
                                                    $("#" + configData2.closeButtonId).on("click", function () {
                                                        that.viewMergedPdf(ids, parentId, relId, udoIdList, data, function () {
                                                            location.reload();
                                                        });
                                                    });
                                                }
                                                else {
                                                    that.viewMergedPdf(ids, parentId, relId, udoIdList, data, function () {
                                                        location.reload();
                                                    });
                                                }
                                            });
                                        },
                                        cleanUp() {
                                            Utilities_1.synUtil.endAjaxProgress("#" + configData.okButtonId);
                                        },
                                        additionalData: dataobj
                                    });
                                });
                            }),
                        });
                    });
                });
            },
            cleanUp() {
                Utilities_1.synUtil.endAjaxProgress();
            },
            additionalData: { "cefunc.221action": "checkudosexist" }
        });
    }
}
exports.instructionProcessingMatrix = instructionProcessingMatrix;
instructionProcessingMatrix.DescriptionPaneHeight = 35;
